import React, { useCallback, useContext } from 'react';
import CreateASpoolContext from '../../../../context/createASpool/createASpoolContext';
import themeContext from '../../../../context/theme/themeContext';
import Button from '../../../../components/Button';
import { StepButtonArrowIcon } from '../../../../assets/icons';
import { useWeb3React } from '@web3-react/core';
import modalContext from '../../../../context/modal/modalContext';

const StepButtons: React.FC = () => {
    const { account } = useWeb3React();

    const {
        steps,
        currentStep,
        selectedAsset,
        selectedRiskModel,
        spoolFee,
        riskTolerance,
        spoolName,
        allocations,
        back,
        next,
        createSpool,
        validateSpoolName,
    } = useContext(CreateASpoolContext);

    const { theme } = useContext(themeContext);

    const { openModal } = useContext(modalContext);

    const hasPrevious = currentStep > 1;
    const hasNext = currentStep < steps.length;

    const handleCreate = useCallback(() => {
        if (!account || !selectedAsset || !selectedRiskModel || !allocations) return;

        if (!validateSpoolName(spoolName)) return;

        createSpool({
            creator: account,
            name: spoolName,
            vaultFee: spoolFee * 100,
            underlying: selectedAsset,
            riskTolerance,
            riskProvider: selectedRiskModel,
            strategies: Object.keys(allocations),
            proportions: Object.values(allocations),
        });
    }, [
        account,
        selectedAsset,
        selectedRiskModel,
        spoolName,
        spoolFee,
        riskTolerance,
        allocations,
        createSpool,
        validateSpoolName,
    ]);

    return (
        <div className={`step-buttons ${theme}`}>
            <div className='step-label'>
                <span className='previous'>
                    {hasPrevious && steps[currentStep - 2].label}
                </span>
                <span className='next'>{hasNext && steps[currentStep].label}</span>
            </div>
            <div
                className={`buttons-container ${
                    (hasPrevious && hasNext) || (!hasNext && hasPrevious) ? 'both' : ''
                }`}
            >
                <Button onClick={back} className={hasPrevious ? 'back' : ''}>
                    <StepButtonArrowIcon />
                    <span>Back</span>
                </Button>
                {!hasNext && hasPrevious ? (
                    <Button
                        onClick={
                            account ? handleCreate : () => openModal('connectWalletModal')
                        }
                        className='create'
                        disabled={!steps[currentStep - 1].completed}
                    >
                        {account ? 'Create Spool' : 'Connect Wallet'}
                    </Button>
                ) : (
                    <Button
                        onClick={next}
                        className={'next'}
                        disabled={!steps[currentStep - 1].completed}
                    >
                        <span>Next</span>
                        <StepButtonArrowIcon />
                    </Button>
                )}
            </div>
        </div>
    );
};

export default StepButtons;
